import { CloseCircleFilled, SearchOutlined } from '@ant-design/icons'
import env from '@shared/env'
import { Button } from '@shared/innmaxUI/Form'
import cx from 'classnames'
import React from 'react'
import Autocomplete from 'react-google-autocomplete'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

export type SearchControlProps = {
  onPlaceSelected: (place: google.maps.places.PlaceResult) => void
}

function PlaceSearchControl({ onPlaceSelected }: SearchControlProps) {
  const { i18n, t } = useTranslation()

  const [open, setOpen] = React.useState(false)

  const [value, setValue] = React.useState('')

  const [renderKey, setRenderKey] = React.useState(0)

  const handleClearInput = () => {
    setValue('')
    setRenderKey(prevKey => prevKey + 1)
  }

  return (
    <div className="relative w-32 h-32">
      <StyledControl
        id="google-map-autocomplete"
        className={cx({ active: open })}>
        <Autocomplete
          key={renderKey}
          apiKey={env.googleMapsApiKey}
          options={{
            fields: ['geometry'],
            types: ['establishment'],
            strictBounds: false,
            language: i18n.language,
            componentRestrictions: { country: 'tw' },
          }}
          placeholder={t('dashboard:search place')}
          onPlaceSelected={onPlaceSelected}
          onChange={(e: any) => setValue(e.target?.value)}
        />
        {value && (
          <StyledClearButton type="icon" onClick={handleClearInput}>
            <span className="ant-input-clear-icon">
              <CloseCircleFilled />
            </span>
          </StyledClearButton>
        )}
        <button
          title={t('dashboard:search place')}
          onClick={() => setOpen(!open)}>
          <SearchOutlined />
        </button>
      </StyledControl>
    </div>
  )
}

const StyledControl = styled.div`
  display: flex;
  flex-direction: row;
  user-select: none;
  box-shadow: rgb(0 0 0 / 30%) 0px 1px 4px -1px;
  border-radius: 4px;

  background-color: transparent;
  width: 32px;
  height: 32px;
  overflow: hidden;
  position: absolute;
  right: 0;
  transition: width 0.2s;

  &.active {
    width: 240px;
    background-color: rgba(92, 99, 101, 0.5);
    border: 1px solid rgba(142, 142, 142, 0.5);
  }

  input {
    flex: 1;
    border: 0;
    border-radius: 0;
    box-shadow: none;
    padding-left: 16px;
    padding-right: 89px;
    font-size: 15px;
    color: #fff;
    &::placeholder {
      color: #8e8e8e;
    }
  }

  button {
    font-size: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 32px;
    min-height: 32px;
    color: #fff;
    background-color: #0486ff;
    border-radius: 4px;
    box-shadow: 0 2px 6px 0 rgb(0 0 0 / 30%);
    position: absolute;
    right: 0;
    cursor: pointer;

    &.active,
    &:hover {
      background-color: #ffcc2b;
      color: #284d5d;
    }
  }
`

const StyledClearButton = styled(Button)`
  width: 20px;
  height: 20px;
  position: absolute;
  right: 38px !important;
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto;
  box-shadow: none !important;
  background-color: transparent !important;
  min-height: auto !important;
  min-width: auto !important;

  > .ant-input-clear-icon {
    color: #fff;
  }

  > span {
    line-height: 0 !important;

    span {
      margin-right: 0 !important;

      svg {
        width: 12px !important;
      }
    }
  }
`

export default React.memo(PlaceSearchControl)
